import { FlowStepData } from "../Steps/FlowStepData";
import { BaseFlowStepRunner } from "../Steps/BaseFlowStepRunner";
import type { AppGlueAny } from "../../Common/AppGlueAny";

export class FlowStepRunnerRegistrationData {
    type: string;
    private prototype: AppGlueAny;

    constructor(prototype: AppGlueAny, type: string) {
        this.prototype = prototype;
        this.type = type;
    }

    create(data: FlowStepData): BaseFlowStepRunner {
        let flowStep = new this.prototype.constructor();

        flowStep.stepData = data;

        return flowStep;
    }
}

export function RegisterFlowStepRunner(step: BaseFlowStepRunner, forStep: FlowStepData) {
    let prototype = Object.getPrototypeOf(step);

    prototype.__type = forStep.__type;
    FlowStepRunnerRegistration.addRegistration(new FlowStepRunnerRegistrationData(prototype, forStep.__type));
}

export class FlowStepRunnerRegistrationClass {
    private registrations: { [key: string]: FlowStepRunnerRegistrationData } = {};

    addRegistration(data: FlowStepRunnerRegistrationData) {
        this.registrations[data.type] = data;
    }

    getByTypeName(type: string): FlowStepRunnerRegistrationData {
        return this.registrations[type];
    }
}

export const FlowStepRunnerRegistration = new FlowStepRunnerRegistrationClass();
